import { render, staticRenderFns } from "./VsPackagesModal.vue?vue&type=template&id=928ab0b6&"
import script from "./VsPackagesModal.vue?vue&type=script&lang=js&"
export * from "./VsPackagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports